import { SearchParamField } from "@synota-io/synota-shared-ui";
import { useServiceChargeCounterparties } from "../../../../api/hooks/useServiceChargeCounterparties";
import { DashboardCounterpartySearchOption } from "../../../../shared/form/DashboardCounterpartySearchField";

export const useSearchParamsDashboardCounterparty = ({
  uuid,
}: {
  uuid?: string;
}): SearchParamField<DashboardCounterpartySearchOption> => {
  const { counterparties } = useServiceChargeCounterparties({ user_uuid: uuid || "" });

  return {
    deserialize(value) {
      const counterparty = counterparties?.find((counterparty) => counterparty.email === value);
      if (!counterparty) {
        return null;
      }
      return {
        ...counterparty,
        label: counterparty.name || counterparty.email,
        value: counterparty.email,
      };
    },
    serialize(value) {
      return value?.value || "";
    },
  };
};
